import React, { useEffect, useRef } from 'react';
import styles from '../styles/slider.scss';
const Slider = ({ visible = true, min = 0, max = 1, defaultValue = 1, step = 0.01, ignoreId, onChange, onOutsideClick, }) => {
    const containerRef = useRef(null);
    const listeningRef = useRef(false);
    const visibleRef = useRef(visible);
    const ignoreIdRef = useRef(ignoreId);
    useEffect(() => {
        visibleRef.current = visible;
    }, [visible]);
    useEffect(() => {
        ignoreIdRef.current = ignoreId;
    }, [ignoreId]);
    useEffect(() => {
        if (listeningRef.current) {
            return;
        }
        listeningRef.current = true;
        const events = [`click`, `touchstart`];
        // FIXME take a closer look at this
        const handler = (e) => {
            var _a;
            // If the element is not visible, just ignore
            if (!visibleRef.current)
                return;
            const target = e.target;
            if ((target === null || target === void 0 ? void 0 : target.id) !== ignoreIdRef.current &&
                !((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
                // if (!containerRef.current?.contains(e.target)) {
                // If we've clicked anywhere except the ignoreId element
                // fire the onOutsideClick() callback
                onOutsideClick();
            }
        };
        events.forEach((name) => {
            document.addEventListener(name, handler);
        });
        return () => {
            events.forEach((name) => {
                document.removeEventListener(name, handler);
            });
        };
    }, []);
    return visible ? (React.createElement("div", { className: styles.slider_container, ref: containerRef },
        React.createElement("input", { type: 'range', id: 'slider-control', className: styles.slider, min: min, max: max, step: step, defaultValue: defaultValue, onChange: onChange }))) : (React.createElement("div", null));
};
export default Slider;
